import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "progress-bar",
  role: "meter"
}

import { computed } from "vue";
interface ProgressBarProps {
  dangerPercent?: number;
  percentages: number | number[];
  color?: string | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProgressBar',
  props: {
    dangerPercent: { default: 0.8 },
    percentages: {},
    color: { default: "var(--color-primary-base)" }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v42c3e07e": (_ctx.color)
}))

const props = __props;
const percentages = computed(() => {
  if (typeof props.percentages === "number") {
    return [props.percentages];
  }
  return props.percentages ?? [];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(percentages.value, (percentage) => {
      return (_openBlock(), _createElementBlock("div", {
        key: percentage,
        class: _normalizeClass([
        'progress-bar__progress',
        { 'progress-bar__progress--danger': percentage > __props.dangerPercent },
      ]),
        style: _normalizeStyle({ width: `${Math.min(1, percentage) * 100}%` })
      }, null, 6))
    }), 128))
  ]))
}
}

})